module.exports = __webpack_public_path__ + "media/components/sessions/new/uni-login-image-button/unilogin-9693e042c34ecea73b2265302c1a5753.png";